import * as React from 'react';

interface Props {
  url: string;
  text: string;
  locale: string;
  size: 'small' | 'large';
}

const localeTwitterLangMap: { [key: string]: string } = {
  'en-US': 'en',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
};

export const TwitterShareButton = ({ url, text, locale, size }: Props) => {
  const encodedUrl = encodeURI(url);
  const encodedText = encodeURI(text);

  const lang = localeTwitterLangMap[locale || 'ja-JP'];

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://platform.twitter.com/widgets.js';

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}&lang=${lang}&size=${size}`}
        className="twitter-share-button"
        data-show-count="false"
      >
        <p></p>
      </a>
    </div>
  );
};
